import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_120: FaireProductEntity = {
  token: "catalog_prod_prod-120",
  type: "product",
  name: "Reversible Pillow - Retro Santa (Pk/02)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 88.17,
  msrpDollars: 220.43,
  sku: "VI0120",
  caseSize: 2,
  material: "Cotton",
  collectionToken: "col_vintage-holiday",
  categoryTokens: ["catalog_cat_bath"],
  isNew: false,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 70,
  description: "Beautiful Vintage Holiday piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
